import { render, staticRenderFns } from "./RearMainBody.vue?vue&type=template&id=e8cf57e4"
import script from "./RearMainBody.vue?vue&type=script&lang=js"
export * from "./RearMainBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports